import { Alert, Input, InputNumber, Modal, Space } from "antd"
import { useEffect, useState } from "react"
import LabeledSwitch from "../../common/LabeledSwitch"
import { defaultTaxRate, rateFractionToPercent, ratePercentToFraction, TaxRate } from "../../../domain/invoicing/taxRate"
import { useUpdateTaxRateMutation } from "../../../domain/invoicing/taxRatesQueries"
import { getTaxRateErrors } from "./invoicingSettingsModel"

type Props = {
  isOpen: boolean
  onClose: () => void
  taxRate?: TaxRate
}

const EditTaxRateModal = ({ isOpen, onClose, taxRate }: Props) => {
  const [state, setState] = useState<TaxRate>(defaultTaxRate())
  const [errors, setErrors] = useState<string[]>([])
  const updateTaxRateMutation = useUpdateTaxRateMutation()

  useEffect(() => {
    setState(taxRate ?? defaultTaxRate())
  }, [taxRate])

  const handleSave = () => {
    const errors = getTaxRateErrors(state)
    setErrors(errors)

    if (errors.length > 0) {
      return
    }

    const name = state.name.trim()
    const data = {
      taxRateId: taxRate?.id ?? '',
      name: taxRate?.name !== name ? name : undefined,
      rate: taxRate?.rate !== state.rate ? state.rate : undefined,
      isDefault: taxRate?.isDefault !== state.isDefault ? state.isDefault : undefined
    }
    updateTaxRateMutation.mutate(data, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return <Modal
    title="Manage Tax Rate"
    open={isOpen}
    onCancel={onClose}
    okText="Save"
    onOk={handleSave}
    okButtonProps={{ disabled: updateTaxRateMutation.isLoading, loading: updateTaxRateMutation.isLoading }}
    cancelButtonProps={{ disabled: updateTaxRateMutation.isLoading }}
  >
    <Space direction="vertical" size="large">
      <Space>
        <div>
          Name
          <br/>
          <Input
            value={state.name}
            onChange={(e) => setState({...state, name: e.target.value})}
            maxLength={100}
          />
        </div>
        <div>
          Rate
          <br/>
          <InputNumber
            addonAfter="%"
            value={rateFractionToPercent(state.rate)}
            onChange={(value) => setState({...state, rate: ratePercentToFraction(value)})}
          />
        </div>
      </Space>
      {errors.length > 0 && <Alert message={errors.map((x, i) => <div key={i}>{x}</div>)} type="error" showIcon={true} />}
      <LabeledSwitch label="Set as Default" value={state.isDefault} onChange={(value) => setState({...state, isDefault: value})} />
    </Space>
  </Modal>
}

export default EditTaxRateModal